import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'error-page',
  templateUrl: './error-page.component.html',
  standalone: false
})
export class ErrorPageComponent implements OnInit {
  error: string;

  constructor(
    private activeRoute: ActivatedRoute,
    titleService: Title
  ) {
    titleService.setTitle('Fel - Ecus ECOM');
  }

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('ecom-loaded');

    this.activeRoute.queryParams.subscribe(params => {
      if (params['err'] && params['err'] === '500') {
        this.error = 'Tillfällig server-fel';
      } else {
        this.error = 'Okänt fel';
      }
    });
  }
}
